import React from "react";
import CustomSpinner from "../infrastructure/customSpinner";
import NeshanMap from "./NeshanMap";

export interface IMapProps {
    cityName?: string;
    lat?: number | null;
    lng?: number | null;
    onChangeMarker?: (lat?: number | null, lng?: number | null) => void;
    disableChangeMarker?: boolean;
}

export interface IMapStates {
    lat?: number | null;
    lng?: number | null;
    loading: boolean;
    currentCityName?: string;
}

interface SearchResult {
    items?: Item[];
}

interface Item {
    type?: string;
    location?: { x: number; y: number; };
}

const SimpleMap = (props: IMapProps) => {

    const [position, setPosition] = React.useState<IMapStates>({ lat: props.lat, lng: props.lng, loading: false, currentCityName: !props.lat || !props.lng ? undefined : props.cityName });
    let { lat, lng } = position;

    if (props.cityName !== position.currentCityName) {
        fetch("https://api.neshan.org/v1/search?term=" + props.cityName + "&lat=35.7&lng=51.4", {
            method: 'GET',
            headers: {
                'Api-Key': 'service.090d971e926d45969bf07289530ee4c9'
            }
        }).then(async (response) => {
            let result = await response.json() as SearchResult;
            let city = result?.items?.find(i => i.type === "city_landmark" || i.type === "town_landmark");
            setPosition({ lat: city?.location?.y, lng: city?.location?.x, currentCityName: props.cityName, loading: false });
            if (props.onChangeMarker)
                props.onChangeMarker(city?.location?.y, city?.location?.x);
        });
        lat = null;
        lng = null;
        position.loading = true;
    }

    if (!lat || !lng || !props.cityName) {
        if (position.loading)
            return (<CustomSpinner />);
        return (< div > لطفا شهر را انتخاب نمایید</div>);
    }

    return (
        <NeshanMap
            options={{
                maptype: 'dreamy',
                poi: true,
                traffic: false,
                center: [lat, lng],
                zoom: 13
            }}
            onInit={(L: any, myMap: any) => {
                let marker = L.marker([lat, lng])
                    .addTo(myMap);
                if (!props.disableChangeMarker)
                    myMap.on('click', function (e: any) {
                        marker.setLatLng(e.latlng);
                        if (props.onChangeMarker)
                            props.onChangeMarker(e.latlng.lat, e.latlng.lng);
                        setPosition({ lat: e.latlng.lat, lng: e.latlng.lng, currentCityName: position.currentCityName, loading: false });
                    });
            }}
        />
    );
}

export default SimpleMap;